import { LocationSnippetProps } from "./types";
import classes from "./location-snippet.module.scss";

export const LocationSnippet = ({ text }: LocationSnippetProps) => {
    return (
        <div className={classes["location-snippet"]}>
            <span className={classes["location-snippet__dot"]} />
            {text || "Домодедовская, Орехово, Москва"}
        </div>
    );
};